<!-- <div class="error-page">
	<h1>Error al cargar la página</h1>
	<p>Lo sentimos, ocurrió un problema al cargar esta página. Por favor, intenta nuevamente más tarde.</p>
	<a routerLink="/">Volver al inicio</a>
</div> -->
<div class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
	<div class="text-center">
		<p class="text-base font-semibold text-[#ec6726]">404</p>
		<h1 class="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl font-ubuntu">
			Página no encontrada
		</h1>
		<p class="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8 font-ubuntu">
			Lo sentimos, no pudimos encontrar la página que estás buscando.
		</p>
		<div class="mt-10 flex items-center justify-center gap-x-6">
			<a
				routerLink="/"
				class="rounded-md bg-[#ec6726] px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-[#4d4d4d] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#4d4d4d]"
				>Regresar al home</a
			>
		</div>
	</div>
</div>
